import React, { Component } from "react";
import PropTypes from "prop-types";

import Icon from "../Icon";
import styles from "./UserHeader.css";

class UserHeader extends Component {
  render() {
    const { person } = this.props;

    return (
      <div className={styles.header}>
        <div className={styles.content}>
          {
            person.avatar_url ?
              <img src={person.avatar_url} alt="Profile picture" className={styles.avatar}/> :
              <Icon name="avatar" path="img" description="Avatar Placeholder" className={styles.avatar}/>
          }
          <div className={styles.displayName}>{person.display_name}</div>

          <div className={styles.bioContainer}>
            <div className={styles.bio}>{person.bio_line}</div>

            { person.social_profiles ? (
              <div className={styles.socialIcons}>
                { person.social_profiles.facebook ? (
                  <a target="_blank" href={person.social_profiles.facebook}>
                    <Icon name={"facebook-inverse"} path="img" description={"facebook"} className={styles.icon}/>
                  </a>
                ) : null }
                { person.social_profiles.twitter ? (
                  <a target="_blank" href={person.social_profiles.twitter}>
                    <Icon name={"twitter-inverse"} path="img" description={"twitter"} className={styles.icon}/>
                  </a>
                ) : null }
                { person.social_profiles.linkedin ? (
                  <a target="_blank" href={person.social_profiles.linkedin}>
                    <Icon name={"linkedin-inverse"} path="img" description={"linkedin"} className={styles.icon}/>
                  </a>
                ) : null }
                { person.social_profiles.instagram ? (
                  <a target="_blank" href={person.social_profiles.instagram}>
                    <Icon name={"instagram-inverse"} path="img" description={"instagram"} className={styles.icon}/>
                  </a>
                ) : null }
              </div>
            ) : null }
          </div>
        </div>
      </div>
    );
  }
}

UserHeader.propTypes = {
  person: PropTypes.object.isRequired,
};

export default UserHeader;
